import RouteContainer from 'components/RouteContainer';
import { PATHS } from 'constants/paths';
import React, { lazy } from 'react';
import { Switch } from 'react-router-dom';

const Home = lazy(() => import('./pages/Home'));

const UserAdmin = lazy(() => import('./pages/UserAdmin'));
const EddrOverview = lazy(() => import('./pages/Eddr/Overview'));
const EddrOperationsLogs = lazy(() => import('./pages/Eddr/OperationsLogs'));
const EddrOperationalLogsMobile = lazy(() => import('./pages/Eddr/OperationsLogs/mobile'));
const EddrSafety = lazy(() => import('./pages/Eddr/Safety'));
const EddrHome = lazy(() => import('./pages/Eddr/Home'));
const GlobalFeedbackPage = lazy(() => import('./pages/GlobalFeedbackPage'));
const EddrFluids = lazy(() => import('./pages/Eddr/Fluids'));
const EddrTrajectory = lazy(() => import('./pages/Eddr/Trajectory'));
const EddrBHA = lazy(() => import('./pages/Eddr/BHA'));
const EddrWellActivityHistory = lazy(() => import('./pages/Eddr/WellActivityHistory'));

const LessonsLearntRegister = lazy(() => import('./pages/LessonsLearnt/LessonsLearntRegister'));
const LessonsLearntWell = lazy(() => import('./pages/LessonsLearnt/LessonsLearntWell'));
const LessonsLearntView = lazy(() => import('./pages/LessonsLearnt/LessonsLearntView'));
const DrillxCockpit = lazy(() => import('./pages/DrillxCockpit'));

const AdminPo = lazy(() => import('./pages/AdminPo'));

const Routes: React.FC = () => {
  const browserDetail = navigator.userAgent;

  const isMobile =
    /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(browserDetail) ||
    /\b(Android|Windows Phone|iPad|iPod)\b/i.test(browserDetail);

  return (
    <Switch>
      <RouteContainer
        exact
        isMobile={isMobile}
        withMobileWellSelect={false}
        path={PATHS.HOME}
        component={isMobile ? EddrHome : Home}
      />

      <RouteContainer path={PATHS.DRILLX_COCKPIT} component={DrillxCockpit} />
      <RouteContainer path={PATHS.EDDR_OVERVIEW} isMobile={isMobile} component={EddrOverview} />
      <RouteContainer
        path={PATHS.EDDR_OPERATIONS_LOG}
        isMobile={isMobile}
        component={isMobile ? EddrOperationalLogsMobile : EddrOperationsLogs}
      />
      <RouteContainer path={PATHS.EDDR_FLUIDS} component={EddrFluids} />
      <RouteContainer path={PATHS.EDDR_SAFETY} component={EddrSafety} />
      <RouteContainer path={PATHS.EDDR_TRAJECTORY} component={EddrTrajectory} />
      <RouteContainer path={PATHS.EDDR_BHA} component={EddrBHA} />
      <RouteContainer path={PATHS.EDDR_WELL_ACTIVITY_HISTORY} component={EddrWellActivityHistory} />
      <RouteContainer path={PATHS.LESSONS_LEARNT_REGISTER} component={LessonsLearntRegister} />
      <RouteContainer path={PATHS.LESSONS_LEARNT_WELL} component={LessonsLearntWell} />
      <RouteContainer path={PATHS.LESSONS_LEARNT_VIEW} component={LessonsLearntView} />
      <RouteContainer path={PATHS.USER_ADMIN} component={UserAdmin} />

      <RouteContainer path={PATHS.GLOBAL_FEEDBACK} component={GlobalFeedbackPage} />

      <RouteContainer path={PATHS.ADMIN_PO} component={AdminPo} />
    </Switch>
  );
};
export default Routes;
